module.exports = __webpack_public_path__ + "8ce134571430cd42314f2e9fc5239f4a.svg";